import SmartTodoList from './SmartTodoList';
import SmartTodoList1 from "./SmartTodoList1";
import SmartTodoList2 from "./SmartTodoList2";

function App() {
  return (
    <>
      <SmartTodoList />
    </>
  );
}

export default App;
